import { userRole } from "../utils"
import { view as Dashboard } from "../modules/dashboard"
import { UserListContainer, UserDetailContainer } from "../modules/user"
import { OrderQuery, OrderQueryDetail } from "../modules/order-query"
import {
  AnnouncementList,
  AnnouncementDetail,
  AnnouncementListCl,
  AnnouncementFormCl
} from "../modules/announcement"
import { CompanyListContainer, CompanyForm } from "../modules/company"
import {
  BackDeviceContainer,
  BackDeviceDetailContainer
} from "../modules/back-device"
import {
  CategoryListContainer,
  CategoryDetailContainer
} from "../modules/category"
import { Message } from "../modules/message"
import { ProductContainer, ProductCl, ProductDetail } from "../modules/product"
import {
  MaintainServiceContainer,
  MaintainServiceDetailContainer
} from "../modules/maintain-service"
import {
  MaintainHistoryContainer,
  MaintainHistoryDetailContainer
} from "../modules/maintain-history"
import { OrderHistoryContainer } from "../modules/order-history"
import { DataImportContainer } from "../modules/data-import"
import {
  OrderClListContainer,
  OrderClContainer,
  // OrderAuditClListContainer,
  // OrderAuditClContainer,
  PdfContainer
} from "../modules/order-client"
import { OrderExportContainer } from "../modules/order-export"
import { ChatExportContainer } from "../modules/chat-export"
import { ContractProducts } from "../modules/contract"
import { PricebookListContainer, PricebookDetail } from "../modules/pricebook"

const themeRoutes = (role) => {
  const {
    SALES_ASSISTANT,
    SUPERVISOR,
    ENGINEER,
    CUSTOMER_PURCHASER,
    CUSTOMER
  } = userRole

  switch (role) {
    case SALES_ASSISTANT:
    case SUPERVISOR:
    case ENGINEER:
      return [
        {
          path: "/dashboard",
          name: "首頁",
          icon: "ti-dashboard",
          component: Dashboard
        },
        {
          path: "/announcement",
          name: "公告",
          icon: "mdi mdi-bulletin-board",
          component: AnnouncementList,
          subRoutes: [
            {
              path: "/announcement/detail",
              component: AnnouncementDetail
            },
            {
              path: "/announcement/detail/:id",
              component: AnnouncementDetail
            }
          ]
        },
        {
          collapse: true,
          path: "/maintainance",
          name: "系統資料維護",
          state: "maintainance",
          icon: "mdi mdi-file",
          subRoutes: [],
          child: [
            {
              path: "/maintainance/maintain-company",
              name: "公司維護",
              icon: "mdi mdi-briefcase",
              component: CompanyListContainer,
              subRoutes: [
                {
                  path: "/maintainance/maintain-company/detail",
                  component: CompanyForm
                },
                {
                  path: "/maintainance/maintain-company/detail/:id",
                  component: CompanyForm
                }
              ]
            },
            {
              path: "/maintainance/maintain-user",
              name: "使用者維護",
              icon: "mdi mdi-account",
              component: UserListContainer,
              subRoutes: [
                {
                  path: "/maintainance/maintain-user/detail",
                  component: UserDetailContainer
                },
                {
                  path: "/maintainance/maintain-user/detail/:id",
                  component: UserDetailContainer
                }
              ]
            },
            {
              path: "/maintainance/backdevice",
              name: "設備維護",
              icon: "ti-harddrive",
              component: BackDeviceContainer,
              subRoutes: [
                {
                  path: "/maintainance/backdevice/detail",
                  component: BackDeviceDetailContainer
                },
                {
                  path: "/maintainance/backdevice/detail/:id",
                  component: BackDeviceDetailContainer
                }
              ]
            },
            {
              path: "/maintainance/category",
              name: "類別維護",
              icon: "mdi mdi-file-tree",
              component: CategoryListContainer,
              subRoutes: [
                {
                  path: "/maintainance/category/detail",
                  component: CategoryDetailContainer
                },
                {
                  path: "/maintainance/category/detail/:id",
                  component: CategoryDetailContainer
                }
              ]
            },
            {
              path: "/maintainance/product",
              name: "產品維護",
              icon: "mdi mdi-shape-plus",
              component: ProductContainer,
              subRoutes: [
                {
                  path: "/maintainance/product/detail",
                  component: ProductDetail
                },
                {
                  path: "/maintainance/product/detail/:id",
                  component: ProductDetail
                }
              ]
            },
            {
              path: "/maintainance/maintain-history",
              name: "耗材更換紀錄",
              icon: "mdi mdi-cached",
              component: MaintainHistoryContainer,
              subRoutes: [
                {
                  path: "/maintainance/maintain-history/detail",
                  component: MaintainHistoryDetailContainer
                },
                {
                  path: "/maintainance/maintain-history/detail/:id",
                  component: MaintainHistoryDetailContainer
                }
              ]
            },
            {
              path: "/maintainance/maintain-service",
              name: "叫修紀錄",
              icon: "fas fa-wrench",
              component: MaintainServiceContainer,
              subRoutes: [
                {
                  path: "/maintainance/maintain-service/detail",
                  component: MaintainServiceDetailContainer
                },
                {
                  path: "/maintainance/maintain-service/detail/:id",
                  component: MaintainServiceDetailContainer
                }
              ]
            },
            {
              path: "/maintainance/pricebook",
              name: "價目表維修紀錄",
              icon: "fas fa-wrench",
              component: PricebookListContainer,
              subRoutes: [
                {
                  path: "/maintainance/pricebook/detail",
                  component: PricebookDetail
                },
                {
                  path: "/maintainance/pricebook/detail/:id",
                  component: PricebookDetail
                }
              ]
            }
          ]
        },
        {
          path: "/product",
          name: "產品首頁",
          icon: "mdi mdi-cart",
          component: ProductCl
        },
        {
          collapse: true,
          path: "/order",
          name: "訂單相關功能",
          icon: "mdi mdi-cart",
          state: "order",
          subRoutes: [],
          child: [
            {
              path: "/order/order-history",
              name: "訂單修改記錄",
              icon: "mdi mdi-pencil",
              component: OrderHistoryContainer,
              subRoutes: []
            },
            {
              path: "/order/maintain-order",
              name: "訂單查詢",
              icon: "mdi mdi-cart",
              component: OrderQuery,
              subRoutes: [
                {
                  path: "/order/maintain-order/detail/:id",
                  component: OrderQueryDetail
                }
              ]
            }
          ]
        },
        {
          path: "/data-import",
          name: "資料匯入",
          icon: "mdi mdi-cloud-upload",
          component: DataImportContainer
        },
        {
          collapse: true,
          path: "/data-export",
          name: "資料匯出",
          icon: "fas fa-download",
          state: "export",
          subRoutes: [],
          child: [
            {
              path: "/data-export/export-order",
              name: "訂單匯出",
              icon: "mdi mdi-cloud-download",
              component: OrderExportContainer,
              subRoutes: []
            },
            {
              path: "/data-export/export-chat",
              name: "聊天紀錄匯出",
              icon: "mdi mdi-cloud-download",
              component: ChatExportContainer,
              subRoutes: []
            }
          ]
        },
        {
          path: "/message",
          name: "訊息中心",
          icon: "mdi mdi-message",
          component: Message,
          subRoutes: [
            {
              path: "/message/:chatRoomId/:sender",
              component: Message
            }
          ]
        },
        {
          path: "/",
          pathTo: "/dashboard",
          name: "首頁",
          redirect: true
        }
      ]
    case CUSTOMER_PURCHASER:
    case CUSTOMER:
      return [
        {
          path: "/dashboard",
          name: "首頁",
          icon: "ti-dashboard",
          component: Dashboard
        },
        {
          path: "/announcement",
          name: "公告",
          icon: "mdi mdi-bulletin-board",
          component: AnnouncementListCl,
          subRoutes: [
            {
              path: "/announcement/detail/:id",
              component: AnnouncementFormCl
            }
          ]
        },
        {
          path: "/contractProducts",
          name: "合約品項",
          icon: "mdi mdi-cart",
          component: ContractProducts
        },
        {
          path: "/product",
          name: "產品首頁",
          icon: "mdi mdi-cart",
          component: ProductCl
        },
        {
          collapse: role === CUSTOMER_PURCHASER,
          path: "/order",
          name: role === CUSTOMER_PURCHASER ? "訂單管理" : "訂單紀錄",
          icon: "mdi mdi-file",
          component: OrderClListContainer,
          subRoutes: [
            {
              path: "/order/detail/:id",
              component: OrderClContainer
            }
          ],
          child: [
            {
              path: "/order/maintain-order",
              name: "訂單明細",
              icon: "mdi mdi-history",
              component: OrderClListContainer,
              subRoutes: [
                {
                  path: "/order/maintain-order/detail/:id",
                  component: OrderClContainer
                },
                {
                  path: "/order/maintain-order/pdf/:id",
                  component: PdfContainer
                }
              ]
            }
          ]
        },
        {
          path: "/message",
          name: "訊息中心",
          icon: "mdi mdi-message",
          component: Message
        },
        {
          path: "/",
          pathTo: "/dashboard",
          name: "Dashboard",
          redirect: true
        }
      ]
    default:
      return []
  }
}

export default themeRoutes
